import classNames from 'classnames'

import { Button, CustomField, Modal } from '@/shared'
import { type INewAdminDto } from '@App/types/adminsTypes'

import style from './AddAdminModal.module.scss'
import { useFields } from './useFields'

interface IProps {
    show: boolean
    setShow: (show: boolean) => void
    onAddAdminCallback: (dto: INewAdminDto) => void
}

export const AddAdminModal = (props: IProps) => {
    const { show, setShow, onAddAdminCallback } = props

    const {
        login,
        loginError,
        onChangeLogin,
        onTouchLogin,
        onZeroLogin,
        password,
        passwordError,
        onChangePassword,
        onTouchPassword,
        onZeroPassword,
        confirmPassword,
        confirmPasswordError,
        onChangeConfirmPassword,
        onTouchConfirmPassword,
        onZeroConfirmPassword,
        isValidFields,
        onInitializeFields
    } = useFields()

    const onCloseModal = () => {
        onInitializeFields()
        setShow(false)
    }

    const onGetFieldsResult = () => {
        onAddAdminCallback({ password: password.value, login: login.value })
        setShow(false)
    }

    const actions = [{ title: 'Добавить', className: 'save', callback: onGetFieldsResult }]

    return (
        <Modal show={show} onClose={onCloseModal}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Добавить Администратора</span>
                </div>
                <div className={style.fields}>
                    <CustomField
                        value={login.value}
                        placeholder={login.placeholder}
                        name={login.name}
                        onChange={onChangeLogin}
                        onFocus={onTouchLogin}
                        onZeroText={onZeroLogin}
                        error={loginError}
                    />
                    <CustomField
                        value={password.value}
                        placeholder={password.placeholder}
                        name={password.name}
                        onChange={onChangePassword}
                        onFocus={onTouchPassword}
                        onZeroText={onZeroPassword}
                        error={passwordError}
                    />
                    <CustomField
                        value={confirmPassword.value}
                        placeholder={confirmPassword.placeholder}
                        name={confirmPassword.name}
                        onFocus={onTouchConfirmPassword}
                        onChange={onChangeConfirmPassword}
                        onZeroText={onZeroConfirmPassword}
                        error={confirmPasswordError}
                    />
                </div>
                <div className={style.actions}>
                    {actions.map((action) => {
                        const { title, callback, className } = action
                        return (
                            <Button
                                key={title}
                                disabled={isValidFields}
                                className={classNames(style.btn, style[className])}
                                onClick={callback}
                            >
                                {title}
                            </Button>
                        )
                    })}
                </div>
            </div>
        </Modal>
    )
}
